export default __webpack_public_path__ + "static/media/Ancient Scroll.df565c9f.jpg";